import React from "react";
import "./style.css";
import { HelperText } from "../Form";
import helperIcon from "./info.svg";

export default function NameValueCard(props) {
  const { value, name, subTitle, helperText, color = "gray" } = props;
  return (
    <div className="nameValueCard">
      <div className={`light${color} value`}>{value}</div>
      <div className={`${color} name`}>
        <div className="name-group">
          <div>
            {name}
            {helperText && (
              <span className="info">
                <HelperText
                  helperTextMsg={helperText}
                  color="#ffffff"
                  icon={helperIcon}
                />
              </span>
            )}
          </div>
          {subTitle && <div> {subTitle}</div>}
        </div>
      </div>
    </div>
  );
}
